<div class="layout-menu-wrapper" [class.layout-menu-dark]="app.darkMenu" (click)="appMain.onMenuClick($event)">
        <div class="layout-menu-container">

            <ul class="layout-menu">
                <li app-menuitem *ngFor="let item of model; let i = index;" [item]="item" [index]="i" [root]="true"></li>
            </ul>
        </div>
</div>

